import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const columnInputs = [
  {
    name: "desktopWidth",
    type: "string",
    enum: ["3", "4", "6", "8", "9", "12"],
    defaultValue: "4",
    required: true,
  },
  {
    name: "tabletWidth",
    type: "string",
    enum: ["3", "4", "6", "8", "9", "12"],
    required: false,
  },
] as const satisfies Inputs;

export type ColumnProps = PropsWithBuilderChildren<
  BuilderComponentProps<typeof columnInputs>
>;

export const ColumnComponent: RegisteredComponent = {
  name: "Column",
  component: dynamic(() => import("./Column").then((mod) => mod.Column)),
  inputs: columnInputs,
  canHaveChildren: true,
  requiresParent: {
    component: "Row",
    message: "'Column' components can only be added inside a 'Row'",
  },
};
